<template>
    <div :class="containerClass">
        <Eadge :class="firstEdgeClass" />
        <slot name="content" />
        <Eadge :class="secondEdgeClass" />
    </div>
</template>

<script>
export default {
    props: {
        firstEdgeClass : {
            type: String,
            default: 'curved-icon-start',
        },
        secondEdgeClass : {
            type: String,
            default: 'curved-icon-end',
        },
        containerClass: {
            type: String,
            default: '#f1f1f1',
        },
    },
}
</script>